export const roomWantedKeys = {
  all: ['room-wanted'],
  list: (params: any) => ['room-wanted', 'list', params],
  detail: (id: any) => ['room-wanted', 'detail', id],
};
